<template>
    <div id="appStyle">
        <el-timeline :reverse="true">
            <el-timeline-item v-for="(item, key) in timeLineData" :key="key" placement="top" :color="colorArr[key % 4]">
                <div class="leftStyle">
                    <div>
                        <div>登记人：{{ item.createdBy }}</div>
                    </div>
                    <div style="margin-top: 8px;">
                        <div>登记时间：{{ item.createdTime }}</div>
                    </div>
                </div>
                <div style="margin-top: -20px;">
                    <el-card style="width: 50%">
                        <div style="display: flex;">
                            <div style="margin-right: 10px;">完好：{{ item.intact || 0 }}</div>
                            <div style="margin-right: 10px;">破损：{{ item.damaged || 0 }}</div>
                            <div>漏件：{{ item.missingParts || 0 }}</div>
                        </div>
                        <div style="display: flex;">
                            <div style="margin-right: 20px;">是否理赔：{{ item.claimFlagLabel || '--' }}</div>
                            <div style="margin-right: 10px;">理赔金额：{{ item.claimAmount || 0 }}</div>
                        </div>
                    </el-card>
                </div>
            </el-timeline-item>
        </el-timeline>
    </div>
</template>
<script>
export default {
    props: {
        timeLineData: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            colorArr: ['#f56a00', '#7265e6', '#ffbf00', '#00a0e9']
        };
    },
    created() { },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.leftStyle {
    position: absolute;
    left: -200px;
    top: 1px;
    font-size: 12px;
}


#appStyle {
    position: relative;
    top: 0px;
    left: 320px;
    width: 100%;
}
</style>